import React from 'react'
import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg'
import { ReactComponent as MessageIcon } from 'assets/icons/message-full.svg'
import s from './EssayReviewListCard.module.scss'
import LoaderImg from '../LoaderImg/LoaderImg'

const STATUS_CLASS = {
	submitted_for_review: 'review',
	draft_only: 'draft',
	approved: 'approved',
	revision_requested: 'revision',
	updating: 'updating',
}

const EssayReviewListCard = ({
	title = 'Essay',
	statusLabel = '',
	statusKey = 'draft_only',
	dateLabel = '',
	hasNew = false,
	unreadFeedbackCount = 0,
	versionsCount = 0,
	showVersionsCount = true,
	active = false,
	onClick = () => {},
	className = '',
	isLoading = false,
}) => {
	const statusClass = STATUS_CLASS[statusKey] || 'draft'
	const unreadCount = Number(unreadFeedbackCount) || 0
	const versionTotal = Number(versionsCount) || 0

	return (
		<button
			type="button"
			className={`${s.card} ${active ? s.cardActive : ''} ${s[statusClass]} ${className} ${isLoading ? s.loading : ''}`.trim()}
			onClick={onClick}
		>
			<div className={s.cardTop}>
				<div className={s.cardLeft}>
					<span className={s.cardIcon} aria-hidden>
						<DockIcon />
					</span>
					<span className={s.cardStatus}>
						{isLoading ? (
							<span className={s.skeleton}>
								<LoaderImg />
							</span>
						) : (
							statusLabel
						)}
					</span>
				</div>
				{hasNew && (
					<div className={s.cardRight}>
						<span className={s.cardNew}>NEW</span>
					</div>
				)}
			</div>

			<div className={s.cardTitle}>
				{isLoading ? (
					<span className={s.skeleton}>
						<LoaderImg />
					</span>
				) : (
					title
				)}
			</div>

			<div className={s.cardFoot}>
				<div className={s.cardDateWrap}>
					<span className={s.cardClock} aria-hidden>
						<ClockIcon />
					</span>
					<span className={s.cardDate}>
						{isLoading ? (
							<span className={s.skeleton}>
								<LoaderImg />
							</span>
						) : (
							dateLabel
						)}
					</span>
				</div>

				<div className={s.cardInfo}>
					{unreadCount > 0 ? (
						<span className={s.cardFeedback}>
							<MessageIcon />
							<span>+{unreadCount}</span>
						</span>
					) : null}
					{isLoading ? (
						<span className={s.skeleton}>
							<LoaderImg />
						</span>
					) : showVersionsCount && versionTotal > 0 ? (
						<span className={s.cardVersionsCount}>{versionTotal} total</span>
					) : null}
				</div>
			</div>
		</button>
	)
}

export default EssayReviewListCard
